module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploadImg"
  }, [_c('div', {
    staticClass: "img-div"
  }, _vm._l((_vm.uploadImgList), function(list, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('div', {
      staticStyle: {
        "position": "relative"
      },
      on: {
        "click": function($event) {
          return _vm.onSeeOrDel(list)
        }
      }
    }, [_c('img', {
      staticClass: "upload-img-style",
      attrs: {
        "src": require("../assets/attach.png")
      }
    }), _vm._v(" "), (_vm.smallDelIco) ? _c('img', {
      staticClass: "upload-img-del",
      attrs: {
        "src": require("../assets/star.png")
      }
    }) : _vm._e()])])
  }), 0), _vm._v(" "), (_vm.delImgIconShow && _vm.uploadImgState) ? _c('span', {
    staticClass: "attach-icon-minus r35",
    on: {
      "click": function($event) {
        return _vm.onDelClick()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploadImgList.length > 0 && _vm.smallDelIco) ? _c('span', {
    staticClass: "r35 t10",
    staticStyle: {
      "position": "absolute"
    },
    on: {
      "click": _vm.onFinishClick
    }
  }, [_vm._v("完成")]) : _vm._e(), _vm._v(" "), (_vm.addImgIconShow && _vm.uploadImgState) ? _c('span', {
    staticClass: "attach-icon-plus",
    class: {
      't0': _vm.uploadImgList.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.onAttachAdd()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "attachInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.attachBeforeUpload($event)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-551dfb5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload.vue
// module id = 569
// module chunks = 1